







import { Vue, Prop, Component } from 'vue-property-decorator';
@Component
export default class CountTime extends Vue {
  @Prop({ default: 0, type: Number }) secondsToCount;
  @Prop({ default: () => {} }) onFinishCountdown;
  private date: number = 0;
  private now: number = 0;
  private seconds: string = '00';
  private minutes: string = '0';
  private firstTime: boolean = true;

  beforeMount() {
    this.now = this.getCurrentTime();
    let time = new Date();
    time.setSeconds(time.getSeconds() + parseInt(this.secondsToCount));
    this.date = this.truncDate(new Date(time));
  }

  mounted() {
    let timeInterval = window.setInterval(() => {
      if (this.minutes === '00' && this.seconds === '00') {
        this.onFinishCountdown();
        clearInterval(timeInterval);
      } else {
        this.calcTime(this.firstTime);
        this.firstTime = false;
      }
    }, 1000);
  }

  getCurrentTime(): number {
    return this.truncDate(new Date());
  }

  truncDate(date: Date): number {
    return Math.trunc(date.getTime() / 1000);
  }

  calcTime(firstTime: boolean) {
    this.now = this.getCurrentTime();
    const diffTime = Math.max(this.date - this.now, 0);
    this.seconds = this.formatTime(diffTime % 60);
    this.minutes = this.formatTime(Math.trunc(diffTime / 60) % 60);
  }

  formatTime(value: number): string {
    return value.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
  }
}
